export const actionType = {
    SEND_LOG_REQUEST: 'SEND_LOG_REQUEST'
} as const;
